import axios from "axios";
import UTILITY_API from "./utility_api";
import GUIDE_API from "./guide_api";
const guide = {
  Result: (dispatch, query) => {
    let sort = "";
    if (query.sort) {
      sort = query.sort;
    } else {
      if (query.query && query.query.trim() !== "") {
        sort = "_score";
      } else {
        sort = "reldate:desc";
      }
    }

    let primaryIC = query.primaryic;
    if(primaryIC.includes("NIH Common Fund")){
        primaryIC = primaryIC.replace("NIH Common Fund", "OSC,RMOD,Roadmap");
    }

    let url = `${GUIDE_API}/data?perpage=${query.perpage}&sort=${sort}&from=${query.from}&type=${query.type}&parentic=${query.parentic}&primaryic=${primaryIC}&activitycodes=${query.activitycodes}&doctype=${query.doctype}&parentfoa=${query.parentfoa}&daterange=${query.daterange}&clinicaltrials=${query.clinicaltrials}&fields=${query.fields}&spons=${query.spons}&query=${query.query}&apptype=${query.apptype}&noticeSubject=${query.noticeSubject}&category=${query.researchInitiative}`;
    axios.get(url).then(function (response) {
      return dispatch({
        type: "SET_RESULT",
        payload: response.data,
      });
    });
  },
  Aggs: (dispatch, query) => {
    let url = `${GUIDE_API}/aggs?type=${query.type}&parentic=${query.parentic}&primaryic=${query.primaryic}&activitycodes=${query.activitycodes}&doctype=${query.doctype}&parentfoa=${query.parentfoa}&daterange=${query.daterange}&clinicaltrials=${query.clinicaltrials}&fields=${query.fields}&spons=${query.spons}&query=${query.query}&apptype=${query.apptype}&noticeSubject=${query.noticeSubject}`;
    axios.get(url).then(function (response) {
      return dispatch({
        type: "SET_AGGS",
        payload: response.data,
      });
    });
  },
  DefaultAggs: (dispatch) => {
    let url = `${GUIDE_API}/aggs?type=active,activenosis,expired,expirednosis&parentic=all&primaryic=all&activitycodes=all&doctype=all&parentfoa=all&clinicaltrials=all`;
    axios.get(url).then(function (response) {
      return dispatch({
        type: "SET_DEFAULT_AGGS",
        payload: response.data,
      });
    });
  },
  SetFundingInstrument: (dispatch) => {
    let url = `${UTILITY_API}/funding_instrument`;
    axios.get(url).then(function (response) {
      return dispatch({
        type: "SET_FUNDING_INSTRUMENT",
        payload: response.data,
      });
    });
  },
  SetFundingCategory: async (dispatch) => {
    let url = `${UTILITY_API}/funding_category`;
    await axios.get(url).then(function (response) {
      return dispatch({
        type: "SET_FUNDING_CATEGORY",
        payload: response.data,
      });
    });
  },
  SetFundingSubCategory: async (dispatch) => {
    let url = `${UTILITY_API}/funding_sub_category`;
    await axios.get(url).then(function (response) {
      return dispatch({
        type: "SET_FUNDING_SUB_CATEGORY",
        payload: response.data,
      });
    });
  },
  SetPDPI: (dispatch) => {
    let url = `${UTILITY_API}/pd_pi_citizenship`;
    axios.get(url).then(function (response) {
      return dispatch({
        type: "SET_PDPI",
        payload: response.data,
      });
    });
  },
  SetCareerStage: (dispatch) => {
    let url = `${UTILITY_API}/career_stage`;
    axios.get(url).then(function (response) {
      return dispatch({
        type: "SET_CAREER_STAGE",
        payload: response.data,
      });
    });
  },
  SetActivityCodes: (dispatch) => {
    let url = `${UTILITY_API}/activity_codes`;
    axios.get(url).then(function (response) {
      return dispatch({
        type: "SET_ACTIVITY_CODES",
        payload: response.data,
      });
    });
  },
  SetMentored: (dispatch) => {
    let url = `${UTILITY_API}/mentored`;
    axios.get(url).then(function (response) {
      return dispatch({
        type: "SET_MENTORED",
        payload: response.data,
      });
    });
  },
  SetReferenceLetters: (dispatch) => {
    let url = `${UTILITY_API}/reference_letters_min_max`;
    axios.get(url).then(function (response) {
      return dispatch({
        type: "SET_REFERENCE_LETTERS",
        payload: response.data,
      });
    });
  },
  SetFilters: (dispatch, filters) => {
    return dispatch({
      type: "SET_FILTERS",
      payload: filters,
    });
  },
  SetCustomAC: (dispatch, filters) => {
    return dispatch({
      type: "SET_CUSTOM_AC",
      payload: filters,
    });
  },

  ClearFilters: (dispatch) => {
    return dispatch({
      type: "CLEAR_FILTERS",
    });
  },
  ClearCustomAC: (dispatch) => {
    return dispatch({
      type: "CLEAR_CUSTOM_AC",
    });
  },
  SetType: (dispatch, type) => {
    return dispatch({
      type: "SET_TYPE",
      payload: type,
    });
  },
  DateRange: (dispatch, date) => {
    return dispatch({
      type: "SET_POLICY_DATE_RANGE",
      payload: date,
    });
  },
};

export default guide;
